// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__cAjMG","collapsible":"style__collapsible__medhh","icon":"style__icon__9ruUk"};